module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "publish-boxs com-model f-w m-b-15"
  }, [_vm._v(_vm._s(_vm.btnArr[_vm.tabindex].txt))]), _vm._v(" "), _c('div', {
    staticClass: "publish-boxs com-model m-b-15"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("招聘岗位信息")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("招聘类型")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('label', {
    staticClass: "lishlabel",
    class: {
      'lishlabel-active': _vm.category * 1 === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "1")
    },
    on: {
      "change": function($event) {
        _vm.category = "1"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("全职")])]), _vm._v(" "), _c('label', {
    staticClass: "lishlabel",
    class: {
      'lishlabel-active': _vm.category * 1 === 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category),
      expression: "category"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.category, "2")
    },
    on: {
      "change": function($event) {
        _vm.category = "2"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("兼职")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("岗位名称")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入如：操作工，长工等职位",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("岗位类别")]), _vm._v(" "), _c('div', {
    staticClass: "value one-input"
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": _vm.placeholdertxt,
      "options": _vm.industryList
    },
    on: {
      "active-item-change": _vm.handleItemChange,
      "change": _vm.handleVal
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item flex-start",
    staticStyle: {
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("岗位描述")]), _vm._v(" "), _c('div', {
    staticClass: "value skil-box",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请填写500字以内的描述",
      "resize": "none",
      "maxlength": 500
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title-2"
  }, [_vm._v("已选技能关键词")]), _vm._v(" "), _c('div', {
    staticClass: "tag-box"
  }, _vm._l((_vm.skilList), function(tag, index) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          _vm.handleDelTag(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag) + "\n                    ")])
  })), _vm._v(" "), _c('el-input', {
    ref: "skilInputRef",
    attrs: {
      "placeholder": "点击输入关键词回车确认"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.currentAddSkil),
      callback: function($$v) {
        _vm.currentAddSkil = $$v
      },
      expression: "currentAddSkil"
    }
  }), _vm._v(" "), (!_vm.currentAddSkil) ? [_vm._l((_vm.skilTree), function(item) {
    return [_c('div', {
      staticClass: "skil-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "skil-item"
    }, _vm._l((item.children), function(sk, i) {
      return _c('span', {
        key: i,
        on: {
          "click": function($event) {
            _vm.handleAddSkil(sk.name)
          }
        }
      }, [_vm._v(_vm._s(sk.name))])
    }))]
  })] : _c('div', {
    staticClass: "skil-item"
  }, _vm._l((_vm.skilTree), function(sk, i) {
    return _c('span', {
      key: i,
      on: {
        "click": function($event) {
          _vm.handleAddSkil(sk.name)
        }
      }
    }, [_vm._v(_vm._s(sk.name))])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "new-recommend-box"
  }, [_c('img', {
    staticClass: "robote",
    attrs: {
      "src": require("../../assets/images//icon_robot.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', [_vm._v("岗位职责")]), _vm._v(" "), (_vm.aiReleast && _vm.title && _vm.allval.length && !_vm.postDesc) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-b",
    domProps: {
      "innerHTML": _vm._s(_vm.postDesc)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-tit"
  }, [_vm._v("推荐的技能关键词")]), _vm._v(" "), _c('div', {
    staticClass: "label-item"
  }, [(_vm.aiReleast && _vm.title && _vm.allval.length && !_vm.postSkils.length) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.postSkils), function(item) {
    return _c('span', [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btns-box"
  }, [_c('span', {
    staticClass: "refresh",
    on: {
      "click": _vm.getPostInfo
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets//images/icon_refresh.png")
    }
  }), _vm._v(_vm._s(_vm.btnText))]), _vm._v(" "), _c('span', {
    staticClass: "submit",
    on: {
      "click": _vm.handleBatchAddSkil
    }
  }, [_vm._v("直接填入")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "publish-boxs com-model m-b-15"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("岗位要求")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("性别要求")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('label', {
    staticClass: "lishlabel",
    class: {
      'lishlabel-active': _vm.requireSex * 1 === -1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireSex),
      expression: "requireSex"
    }],
    attrs: {
      "type": "radio",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.requireSex, "-1")
    },
    on: {
      "change": function($event) {
        _vm.requireSex = "-1"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("不限")])]), _vm._v(" "), _c('label', {
    staticClass: "lishlabel",
    class: {
      'lishlabel-active': _vm.requireSex * 1 === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireSex),
      expression: "requireSex"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.requireSex, "1")
    },
    on: {
      "change": function($event) {
        _vm.requireSex = "1"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("男性")])]), _vm._v(" "), _c('label', {
    staticClass: "lishlabel",
    class: {
      'lishlabel-active': _vm.requireSex * 1 === 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireSex),
      expression: "requireSex"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.requireSex, "0")
    },
    on: {
      "change": function($event) {
        _vm.requireSex = "0"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("女性")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("年龄要求")]), _vm._v(" "), _c('div', {
    staticClass: "value flex"
  }, [_c('div', {
    staticClass: "input-box",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireMinage),
      expression: "requireMinage"
    }],
    attrs: {
      "type": "text",
      "maxlength": 2,
      "placeholder": "请填写最小年龄要求"
    },
    domProps: {
      "value": (_vm.requireMinage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requireMinage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 8px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    staticStyle: {
      "width": "128px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireMaxage),
      expression: "requireMaxage"
    }],
    attrs: {
      "type": "text",
      "maxlength": 2,
      "placeholder": "请填写最大年龄要求"
    },
    domProps: {
      "value": (_vm.requireMaxage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requireMaxage = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("学历要求")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请学历"
    },
    model: {
      value: (_vm.requireEdu),
      callback: function($$v) {
        _vm.requireEdu = $$v
      },
      expression: "requireEdu"
    }
  }, _vm._l((_vm.eduList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("经验要求")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请学历"
    },
    model: {
      value: (_vm.requireExp),
      callback: function($$v) {
        _vm.requireExp = $$v
      },
      expression: "requireExp"
    }
  }, _vm._l((_vm.expList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("身高")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireHeight),
      expression: "requireHeight"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写对候选人的身高要求",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.requireHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requireHeight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("形象")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireImage),
      expression: "requireImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写对候选人的形象要求",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.requireImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requireImage = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("着装要求")]), _vm._v(" "), _c('div', {
    staticClass: "value input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requireClothing),
      expression: "requireClothing"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写对候选人的着装要求，如是否要穿工服",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.requireClothing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requireClothing = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "publish-boxs com-model"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require mt0"
  }, [_vm._v("薪资结构")]), _vm._v(" "), _c('div', {
    staticClass: "value lishbtn-groups lishbtn-groupsa"
  }, _vm._l((_vm.workTypeList), function(item) {
    return _c('div', {
      staticClass: "button",
      class: {
        active: _vm.workType.indexOf(item) > -1 ? true : false
      },
      on: {
        "click": function($event) {
          _vm.workTypeSel(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n                ")])
  })), _vm._v(" "), (_vm.workTypeMore) ? _c('div', {
    staticClass: "errorTs",
    staticStyle: {
      "margin-left": "0"
    }
  }, [_vm._v("最多选择三个计酬方式")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("薪资范围")]), _vm._v(" "), _c('div', {
    staticClass: "value flex"
  }, [_c('div', {
    staticClass: "input-box min"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minSalary),
      expression: "minSalary"
    }],
    attrs: {
      "maxlength": 6,
      "type": "text",
      "placeholder": "请填写最小薪资"
    },
    domProps: {
      "value": (_vm.minSalary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minSalary = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishline"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box min"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxSalary),
      expression: "maxSalary"
    }],
    attrs: {
      "maxlength": 6,
      "type": "text",
      "placeholder": "请填写最大薪资"
    },
    domProps: {
      "value": (_vm.maxSalary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxSalary = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("招聘人数")]), _vm._v(" "), _c('div', {
    staticClass: "input-box min"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recruitNumber),
      expression: "recruitNumber"
    }],
    attrs: {
      "type": "text",
      "maxlength": 4,
      "placeholder": "请输入整数数字"
    },
    domProps: {
      "value": (_vm.recruitNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recruitNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("工作时间")]), _vm._v(" "), _c('el-time-select', {
    staticClass: "lishinp lishw144",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      },
      "size": "large",
      "placeholder": "上班时间"
    },
    model: {
      value: (_vm.workStartTime),
      callback: function($$v) {
        _vm.workStartTime = $$v
      },
      expression: "workStartTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lishline"
  }), _vm._v(" "), _c('el-time-select', {
    staticClass: "lishinp lishw144",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      },
      "size": "large",
      "placeholder": "下班时间"
    },
    model: {
      value: (_vm.workEndTime),
      callback: function($$v) {
        _vm.workEndTime = $$v
      },
      expression: "workEndTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lishunit",
    staticStyle: {
      "margin-right": "8px",
      "margin-left": "20px"
    }
  }, [_vm._v("共")]), _vm._v(" "), _c('div', {
    staticClass: "input-box min"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workHours),
      expression: "workHours"
    }],
    attrs: {
      "type": "number",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.workHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workHours = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("小时")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require"
  }, [_vm._v("月休天数")]), _vm._v(" "), _c('div', {
    staticClass: "value flex"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择规模"
    },
    model: {
      value: (_vm.dayOffLength),
      callback: function($$v) {
        _vm.dayOffLength = $$v
      },
      expression: "dayOffLength"
    }
  }, [_c('el-option', {
    staticStyle: {
      "color": "#333333 !important"
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("请选择月休天数")]), _vm._v(" "), _vm._l((11), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("天")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require mt5"
  }, [_vm._v("提供宿舍")]), _vm._v(" "), _c('div', {
    staticClass: "lishbtn-groups"
  }, [_c('div', {
    staticClass: "button",
    class: {
      active: this.provideBedroom * 1 == 1
    },
    on: {
      "click": function($event) {
        _vm.provideBedroomSel(1)
      }
    }
  }, [_vm._v("提供宿舍\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      active: this.provideBedroom * 1 == 0
    },
    on: {
      "click": function($event) {
        _vm.provideBedroomSel(0)
      }
    }
  }, [_vm._v("自行安排\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "lishcondition flex"
  }, [(_vm.provideBedroom == 1) ? _c('label', {
    class: {
      'active': _vm.provideRestsubsidy == 1 ? true : false
    },
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideRestsubsidy),
      expression: "provideRestsubsidy"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.provideRestsubsidy, "1")
    },
    on: {
      "change": function($event) {
        _vm.provideRestsubsidy = "1"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("包住")])]) : _vm._e(), _vm._v(" "), _c('label', {
    class: {
      'active': _vm.provideRestsubsidy == 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideRestsubsidy),
      expression: "provideRestsubsidy"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.provideRestsubsidy, "0")
    },
    on: {
      "change": function($event) {
        _vm.provideRestsubsidy = "0"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("无补贴")])]), _vm._v(" "), (_vm.provideBedroom == 1) ? _c('label', {
    class: {
      'active': _vm.provideRestsubsidy == 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideRestsubsidy),
      expression: "provideRestsubsidy"
    }],
    attrs: {
      "type": "radio",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.provideRestsubsidy, "3")
    },
    on: {
      "change": function($event) {
        _vm.provideRestsubsidy = "3"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("外住补贴")])]) : _vm._e(), _vm._v(" "), (_vm.provideBedroom == 0) ? _c('label', {
    class: {
      'active': _vm.provideRestsubsidy == 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideRestsubsidy),
      expression: "provideRestsubsidy"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.provideRestsubsidy, "2")
    },
    on: {
      "change": function($event) {
        _vm.provideRestsubsidy = "2"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("住宿补贴")])]) : _vm._e(), _vm._v(" "), (_vm.provideRestsubsidy * 1 == 2) ? _c('div', {
    staticClass: "lishcond-item-info"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restsubsidys.bufen),
      expression: "restsubsidys.bufen"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.restsubsidys.bufen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.restsubsidys, "bufen", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (_vm.provideRestsubsidy * 1 == 3) ? _c('div', {
    staticClass: "lishcond-item-info"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restsubsidys.waizhu),
      expression: "restsubsidys.waizhu"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.restsubsidys.waizhu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.restsubsidys, "waizhu", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("元")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label require mt5"
  }, [_vm._v("用餐情况")]), _vm._v(" "), _c('div', {
    staticClass: "lishbtn-groups"
  }, [_c('div', {
    staticClass: "button",
    class: {
      active: _vm.provideDiningroom == 1
    },
    on: {
      "click": function($event) {
        _vm.provideDiningroomSel(1)
      }
    }
  }, [_vm._v("食堂用餐\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      active: _vm.provideDiningroom == 0
    },
    on: {
      "click": function($event) {
        _vm.provideDiningroomSel(0)
      }
    }
  }, [_vm._v("自行安排\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "lishcondition flex"
  }, [(_vm.provideDiningroom == 1) ? _c('label', {
    class: {
      active: _vm.provideFood == 1
    },
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideFood),
      expression: "provideFood"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.provideFood, "1")
    },
    on: {
      "change": function($event) {
        _vm.provideFood = "1"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("包吃")])]) : _vm._e(), _vm._v(" "), _c('label', {
    class: {
      active: _vm.provideFood == 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideFood),
      expression: "provideFood"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.provideFood, "0")
    },
    on: {
      "change": function($event) {
        _vm.provideFood = "0"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("无补贴")])]), _vm._v(" "), _c('label', {
    class: {
      active: _vm.provideFood == 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideFood),
      expression: "provideFood"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.provideFood, "2")
    },
    on: {
      "change": function($event) {
        _vm.provideFood = "2"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("补贴")])]), _vm._v(" "), (_vm.provideFood * 1 == 2) ? _c('div', {
    staticClass: "lishcond-item-info"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.foodsubsidy),
      expression: "foodsubsidy"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.foodsubsidy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.foodsubsidy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("元")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "align-items": "flex-start"
    }
  }, [_c('div', {
    staticClass: "label require mt0 mt00"
  }, [_vm._v("福利待遇")]), _vm._v(" "), _c('div', {
    staticClass: "value ",
    staticStyle: {
      "display": "block",
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "flex lishbtn-groups lishbtn-groups-ks"
  }, _vm._l((_vm.totalWelFareList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "button",
      class: {
        active: _vm.welfareSelList.indexOf(item) > -1 ? true : false
      },
      on: {
        "click": function($event) {
          _vm.welfareSel(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n                ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "lishadd flex"
  }, [_c('div', {
    staticClass: "input-box",
    staticStyle: {
      "width": "166px",
      "margin-left": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWelfareName),
      expression: "newWelfareName"
    }],
    attrs: {
      "type": "text",
      "maxlength": 5,
      "placeholder": "请输入文本"
    },
    domProps: {
      "value": (_vm.newWelfareName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWelfareName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.addWelfare
    }
  }, [_vm._v("添加")]), _vm._v(" "), (_vm.welfareMore) ? _c('span', {
    staticClass: "errorTs"
  }, [_vm._v("最多只能选择4个福利待遇")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "publish-boxs com-model"
  }, [_c('div', {
    staticClass: "item",
    staticStyle: {
      "display": "flex",
      "overflow": "inherit"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("视频描述")]), _vm._v(" "), (_vm.recruitVideo) ? _c('div', {
    staticClass: "upload",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": _vm.showVideo
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.recruitVideo + '?vframe/jpg/offset/0'
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "show-icon",
    attrs: {
      "t": "1698290929575",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "10880",
      "width": "50",
      "height": "50"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 64C265.6 64 64 265.6 64 512s201.6 448 448 448 448-201.6 448-448S758.4 64 512 64zM691.2 544l-256 156.8C428.8 704 422.4 704 416 704c-6.4 0-9.6 0-16-3.2C390.4 694.4 384 684.8 384 672L384 352c0-12.8 6.4-22.4 16-28.8 9.6-6.4 22.4-6.4 32 0l256 166.4c9.6 6.4 16 16 16 28.8C704 528 700.8 540.8 691.2 544z",
      "p-id": "10881"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "delete-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.recruitVideo = ''
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1698309963902",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1700",
      "width": "30",
      "height": "30"
    }
  }, [_c('path', {
    attrs: {
      "d": "M505.6 28.16C246.912 28.16 37.12 237.952 37.12 496.64s209.792 468.48 468.48 468.48 468.48-209.792 468.48-468.48S764.288 28.16 505.6 28.16z m283.648 716.928L755.2 779.136c-13.952 13.952-36.736 13.952-50.688 0L506.752 581.248 308.864 779.136c-13.952 13.952-36.736 13.952-50.688 0l-34.048-34.048c-13.952-13.952-13.952-36.736 0-50.688L422.016 496.64 224.256 298.88c-14.08-13.952-14.08-36.736-0.128-50.688l34.048-34.048c13.952-13.952 36.736-13.952 50.688 0l197.76 197.76 197.76-197.76c13.952-13.952 36.736-13.952 50.688 0l34.048 34.048c14.08 13.952 14.08 36.736 0 50.688L591.36 496.64l197.888 197.76c13.952 13.952 13.952 36.736 0 50.688z",
      "fill": "#666666",
      "p-id": "1701"
    }
  })])])]) : _c('div', {
    staticClass: "upload"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1698286063110",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "9071",
      "width": "100",
      "height": "100"
    }
  }, [_c('path', {
    attrs: {
      "d": "M524.8 64c4.693333 0 8.533333 3.84 8.533333 8.533333V490.666667h418.133334c4.693333 0 8.533333 3.84 8.533333 8.533333v46.933333a8.533333 8.533333 0 0 1-8.533333 8.533334H533.333333v418.133333a8.533333 8.533333 0 0 1-8.533333 8.533333h-46.933333a8.533333 8.533333 0 0 1-8.533334-8.533333V554.666667H51.2a8.533333 8.533333 0 0 1-8.533333-8.533334v-46.933333c0-4.693333 3.84-8.533333 8.533333-8.533333H469.333333V72.533333c0-4.693333 3.84-8.533333 8.533334-8.533333h46.933333z",
      "fill": "#ccc",
      "p-id": "9072"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "userbox-file-inp",
    attrs: {
      "type": "file",
      "accept": "”video/*”"
    },
    on: {
      "change": _vm.uploadVideo
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("发布人")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.hrs),
      callback: function($$v) {
        _vm.hrs = $$v
      },
      expression: "hrs"
    }
  }, _vm._l((_vm.hrList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.hrId + '-' + item.hrName
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("发布者手机号码：" + _vm._s(_vm.hrPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("平台代理补贴")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "lishswitch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.switchCheck),
      expression: "switchCheck"
    }],
    staticClass: "switch",
    attrs: {
      "id": "checked_1",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.switchCheck) ? _vm._i(_vm.switchCheck, null) > -1 : (_vm.switchCheck)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.switchCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.switchCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.switchCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.switchCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checked_1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("帮助企业代理发放招聘车补，如无需不必填写")])])]), _vm._v(" "), (_vm.switchCheck) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("面试车补")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carsubsidy),
      expression: "carsubsidy"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.carsubsidy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carsubsidy = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("元/人")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("账户余额")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [(_vm.accountInfo) ? _c('div', {
    staticClass: "lishmoney"
  }, [_vm._v("￥" + _vm._s(_vm.accountInfo.availableFunds))]) : _vm._e(), _vm._v(" "), (_vm.switchCheck) ? _c('span', {
    staticClass: "lishunit"
  }, [_vm._v("账户余额不能少于" + _vm._s(_vm.minaccount) + "元")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "lishbottom clearfix"
  }, [_c('div', {
    staticClass: "lishbttom-btns"
  }, [_c('div', {
    staticClass: "publish-stat-btna",
    on: {
      "click": function($event) {
        _vm.publish(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnArr[_vm.tabindex].btn))]), _vm._v(" "), (_vm.tabindex == 0) ? _c('div', {
    staticClass: "publish-stat-btnb",
    on: {
      "click": function($event) {
        _vm.publish(true)
      }
    }
  }, [_vm._v("暂不发布，帮我保存")]) : _vm._e()])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      }
    }
  }, [(_vm.recruitVideo && _vm.videoVisible) ? _c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.recruitVideo,
      "autoplay": ""
    }
  }) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-title"
  }, [_vm._v("福利待遇"), _c('div', {
    staticClass: "sub"
  }, [_vm._v("（以下福利是公司默认福利待遇，也可根据岗位在下面直接修改，不修改则默认当前设置）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f319780","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/posts/release.vue
// module id = 903
// module chunks = 1